'use client'

import { useEffect } from 'react'
import { LEAD_SOURCE_KEY, firstTouch } from '@/lib/lead-source'

/**
 * Remembers the first page of the visit, its campaign tags and the referring
 * site, once per browser session, for the contact form to send with a lead.
 * Session storage only: it never leaves the browser unless the visitor
 * writes to us.
 */
export function LeadSourceRecorder() {
  useEffect(() => {
    try {
      if (sessionStorage.getItem(LEAD_SOURCE_KEY)) return
      sessionStorage.setItem(LEAD_SOURCE_KEY, JSON.stringify(firstTouch(window.location.href, document.referrer)))
    } catch {}
  }, [])
  return null
}
